import { UniteFOResponseDto } from 'lib_api/lib/api/gen';

import { FicheProfilForceOrdre } from './types';

export function ficheProfilFromDto(
  uniteFO: UniteFOResponseDto,
): FicheProfilForceOrdre {
  return {
    codeUnite: uniteFO.code,
    unite: uniteFO.unite,
    abreviationUnite: uniteFO.abreviation,
    adresse: uniteFO.adresse || undefined,
    codePostal: uniteFO.codePostal || undefined,
    commune: uniteFO.ville || undefined,
    email: uniteFO.email || undefined,
    telephone: uniteFO.telephone || undefined,
  };
}
